import React from 'react';
import PropTypes from 'prop-types';
import { useIntercom } from 'react-use-intercom';

import { useAuth } from '@/lib/auth';

import Badge from '@/components/Badge';
import Button from '@/components/Button';
import Icon from '@/components/Icon';
import Table from '@/components/Table';
import TableCell from '@/components/TableCell';
import Tooltip from '@/components/Tooltip';
import Truncate from '@/components/Truncate';
import Skeleton from '@/components/Skeleton';
import Card from '@/components/Card';

const propTypes = {
  usersList: PropTypes.arrayOf(PropTypes.object).isRequired
};

function AvaUsersList({ usersList }) {
  const { user: currentUser } = useAuth();
  const { showNewMessages } = useIntercom();

  const handleDeactivateUser = (name) => {
    showNewMessages(`Gostaria de desvincular da Ava o usuário ${name}`);
  };

  return (
    <Table className='table-border-separate'>
      <thead>
        <tr>
          <th
            className='border-end border-1 bg-white'
            style={{ maxWidth: '176px' }}
          >
            <span>Nome</span>
          </th>
          <th style={{ maxWidth: '220px' }}>E-mail</th>
          <th style={{ maxWidth: '30px' }}></th>
        </tr>
      </thead>
      <tbody>
        { usersList.map((user, index) => (
          <tr key={index}>
            <td
              className='align-middle border-end border-1 bg-white'
              style={{ maxWidth: '176px' }}
            >
              <div className='d-flex align-items-center'>
                <Truncate>
                  <span className='fw-bold'>{user.name}</span>
                </Truncate>
                { currentUser.id === user.id && <Badge className='ms-1'>você</Badge> }
              </div>
            </td>
            <td className='align-middle' style={{ maxWidth: '220px' }}>
              <Truncate>
                <TableCell value={user.email} />
              </Truncate>
            </td>
            <td className='px-0' style={{ maxWidth: '30px' }}>
              <Tooltip content='Remover usuário da Ava' placement='bottom'>
                <Button
                  variant='link'
                  size='sm'
                  className='px-0'
                  onClick={() => handleDeactivateUser(user.name)}
                >
                  <Icon name='delete' />
                </Button>
              </Tooltip>
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
}

function AvaUsersListSkeleton() {
  return (
    <Card className='p-2 border-light' style={{ minWidth: '502px' }}>
      <Table className='table-border-separate'>
        <thead>
          <tr>
            <th
              className='border-end border-1 position-sticky start-0 bg-white'
              style={{ width: '210px' }}
            >
              <span>Nome</span>
            </th>
            <th style={{ maxWidth: '250px' }}>E-mail</th>
            <th style={{ width: '30px' }}></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td
              className='align-middle border-end border-1 position-sticky start-0 bg-white'
              style={{ width: '210px' }}
            >
              <Skeleton width='100%' />
            </td>
            <td className='align-middle' style={{ maxWidth: '250px' }}>
              <Skeleton width='100%' />
            </td>
            <td className='px-0' style={{ width: '30px' }}>
              <Button
                variant='link'
                size='sm'
                className='text-nowrap px-0'
              >
                <Icon name='delete' />
              </Button>
            </td>
          </tr>
          <tr>
            <td
              className='align-middle border-end border-1 position-sticky start-0 bg-white'
              style={{ width: '210px' }}
            >
              <Skeleton width='100%' />
            </td>
            <td className='align-middle' style={{ maxWidth: '250px' }}>
              <Skeleton width='100%' />
            </td>
            <td className='px-0' style={{ width: '30px' }}>
              <Button
                variant='link'
                size='sm'
                className='text-nowrap px-0'
              >
                <Icon name='delete' />
              </Button>
            </td>
          </tr>
          <tr>
            <td
              className='align-middle border-end border-1 position-sticky start-0 bg-white'
              style={{ width: '210px' }}
            >
              <Skeleton width='100%' />
            </td>
            <td className='align-middle' style={{ maxWidth: '250px' }}>
              <Skeleton width='100%' />
            </td>
            <td className='px-0' style={{ width: '30px' }}>
              <Button
                variant='link'
                size='sm'
                className='text-nowrap px-0'
              >
                <Icon name='delete' />
              </Button>
            </td>
          </tr>
        </tbody>
      </Table>
    </Card>
  );
}

AvaUsersList.propTypes = propTypes;
AvaUsersList.Skeleton = AvaUsersListSkeleton;

export default AvaUsersList;
